export default function TestimonialsSection() {
  return (
    <div className="py-8 md:py-16">
      <div className="mx-auto max-w-5xl px-6">
        <div className="mx-auto max-w-2xl">
          <blockquote>
            <p className="text-lg font-semibold sm:text-xl md:text-3xl">
              I work remotely from home now and I am on computers quite often. I
              think for people in our situations (or even if you are NOT in a
              situation like ours) these steps are 100% necessary!
            </p>

            <div className="mt-12 flex items-center gap-6">
              <img
                className="h-7 w-fit dark:invert"
                src="https://html.tailus.io/blocks/customers/nvidia.svg"
                alt="Nvidia Logo"
                height="20"
                width="auto"
              />
              <div className="space-y-1 border-l pl-6">
                <cite className="font-medium">Jan Nicklasson</cite>
                <span className="text-muted-foreground block text-sm">
                  Techlead, Nvidia
                </span>
              </div>
            </div>
          </blockquote>
        </div>
      </div>
    </div>
  );
}
